<template>
  <div>
    <div class="container">
      <div class="row justify-content-center">
        <div
          class="col-12 bg-cover mt-4"
          style="
            background-image: url(https://images.unsplash.com/photo-1556453007-ee036169934b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80);
            height: 500px;
          "
        ></div>
        <div class="col-12">
          <h1 class="text-center py-3">關於Omega</h1>
        </div>
        <div class="col-8">
          <div class="d-flex flex-column">
            <h2 class="brand-title mt-3">品牌介紹</h2>
            <p class="brand-text">
              歐米茄（OMEGA）是瑞士著名鐘錶製造商，英文名OMEGA，以希臘字母“Ω”命名。歐米茄由路易士·勃蘭特（Louis
              Brandt）創始於1848 年。
            </p>
            <h2 class="brand-title mt-3">品牌故事</h2>
            <p class="brand-text">
              1848年，歐米茄誕生於瑞士西北部的拉紹德芬（La
              Chaux-de-Fonds），創始人路易士·勃蘭特（Louis
              Brandt）在當地辦了一家裝嵌懷錶的小工坊，
              開始了歐米茄初期的製表事業。
              <br />
              <br />
              1894年製造出了“Omega”19令機芯，此機芯獲得歐洲幾家著名天文台頒發的精確計時證書，公司決定以此重新命名，並以希臘字母“Ω”作為標誌，歐米茄名稱自此誕生。
              <br />
              <br />
              歐米茄自成立以來不但致力於打造實用且可靠的時計，更曾在太空和深海中一展身手，在運動計時領域提供精準計時的同時，
              不斷升級研發計時技術與設備。近年來，歐米茄更將機芯提升為高抗磁的至臻天文台機芯，並宣布取得與瑞士聯邦計量研究院（METAS）合作的全新至臻天文台認證（METAS）。
              <br />
              <br />
              歐米茄對於文化事業同樣鼎力支持，從1995年的《黃金眼》（GoldenEye）
              開始，承襲深厚的海軍歷史及鮮明個性，
              歐米茄海馬系列腕錶便成為特工007的選擇，成為他標誌性造型中不可缺少的時計單品，幫助他在嚴峻挑戰中精準地掌控致勝時機。
              歐米茄亦傾力支持社會公益事業，包括為“陽光動力”計劃的環球飛行提供了經濟支持和完整的技術保障；贊助並攜手美好星球基金會拍攝生態紀錄片《海洋宇宙》
              （Planet
              Ocean），致力推動相關海洋環保項目；支持國際奧比斯組織在世界各地治療眼疾以及可防治性盲症的工作等。
              <br />
              <br />
              1969年，NASA為第一次登月做準備，當時第四代超霸系列專業腕錶被選用執行“阿波羅”任務。
              1969年7月21日格林威治標準時間2時56分，
              宇航員尼爾·阿姆斯特朗踏上月球表面，實現了人類首次登月的偉大創舉。
              15分鐘後，巴茲·奧爾德林(Buzz Aldrin) 也踏上月球表面，
              至此，在傳奇的阿波羅11號任務中，超霸系列專業腕錶成為第一塊人類佩戴於月球上的腕表。不久之後，它便被賦予了“月球表”這個著名的稱號。
              直至阿波羅17號的最後一次登月，歐米茄超霸系列專業腕錶在每一次登月任務中都為宇航員提供了最精準的計時保障。
              <br />
              <br />
              2032年第35屆奧運會將成為歐米茄 (OMEGA)
              與奧林匹克結緣百年的傳奇見證。自1932年洛杉磯奧運會起，歐米茄至今已多次次擔任奧運會正式計時，
              並不斷研發並引入前沿高科技計時技術與設備，包括電子發令槍、泳池自動觸摸板和於里約奧運會中首次投入使用、
              每秒可捕捉10,000幅數碼影像的光感應終點攝影機(Scan 'O' Vision
              MYRIA)，保證為各項賽事提供精準計時。
              <br />
              <br />
              除了奧林匹克運動會，歐米茄還擔任包括高爾夫、游泳、田徑、有舵雪橇和帆船等體育項目計時，奠定運動計時為歐米茄的品牌文化元素之一。
            </p>

            <h2 class="brand-title mt-3">品牌特色</h2>
            <p class="brand-text">
              歐米茄“Ω”象徵著事物的伊始與終極，第一與最後，類似於亞洲哲學中“最後意味著最初，結束亦是開始”的循環。
              代表了“完美、極致、卓越、成就”的非凡品質，詮釋出歐米茄追尋“卓越品質”的經營理念和“崇尚傳統，並勇於創新”的精神風範。
              歐米茄由於走時精準，外觀時尚且耐用度高，在中國的銷量一直高居榜首。各大城市甚至一些中小城市都已經有專櫃和售後保障。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <h1 class="text-center py-3 commentTitle">看看他們怎麼說...</h1>
      <div class="card-columns">
        <div class="card">
          <img src="https://watchandbullion.com/wp-content/uploads/Omega-cover.jpeg" class="card-img-top" alt="watch picture" />
          <div class="card-body">
            <h5 class="card-title">非常喜歡Omega</h5>
            <p class="card-text">
              剛入手，太喜歡啦! 下一隻一定也是Omega。
            </p>
          </div>
        </div>
        <div class="card p-3">
          <blockquote class="blockquote mb-0 card-body">
            <p>
              Omega 讚讚讚!!!
            </p>
            <footer class="blockquote-footer">
              <small class="text-muted">
                錶友 <cite title="Source Title">Oscar</cite>
              </small>
            </footer>
          </blockquote>
        </div>
        <div class="card">
          <img src="https://timeandtidewatches.com/wp-content/uploads/2020/02/brucie_d001-1.png" class="card-img-top" alt="watch picture" />
          <div class="card-body">
            <h5 class="card-title">剛買就下水!</h5>
            <p class="card-text">
              潛水錶就是要戴著玩水
            </p>
            <p class="card-text">
              <small class="text-muted">Last updated 3 mins ago</small>
            </p>
          </div>
        </div>
        <div class="card text-center p-3">
          <blockquote class="blockquote mb-0">
            <p>
              CP之王，買就對了!
            </p>
            <footer class="blockquote-footer">
              <small>
                錶友<cite title="Source Title">IloveOmega</cite>
              </small>
            </footer>
          </blockquote>
        </div>
        <div class="card text-center">
          <div class="card-body">
            <h5 class="card-title">買不到勞，買歐也不錯!</h5>
            <p class="card-text">
              勞一直漲，一直缺貨。不等拉，入手Omega。
            </p>
            <p class="card-text">
              <small class="text-muted">Last updated 3 mins ago</small>
            </p>
          </div>
        </div>
        <div class="card">
          <img src="https://timeandtidewatches.com/wp-content/uploads/2017/10/Omega-Seamaster-Aqua-Terra-blue-9.jpg" class="card-img-top" alt="watch picture"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
